import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  overflow-x: hidden;
  flex-direction: row;
  margin: 10% 0% 0 12.625%;

  @media (max-width: 1024px) {
    margin: 0;
    flex-direction: column;
  }

  @media (max-width: 960px) {
    margin: 0;
    flex-direction: column;
  }
`;

export const HelperImage = styled.img`
  width: 60%;

  @media (max-width: 1024px) {
    margin-top: 5%;
    width: 100%;
  }

  @media (max-width: 960px) {
    margin-top: 5%;
    width: 100%;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 45% 0 0;
  max-width: 45%;

  @media (max-width: 1024px) {
    flex: 100% 0 0;
    max-width: 100%;
    margin-top: 15%;
  }

  @media (max-width: 960px) {
    flex: 100% 0 0;
    max-width: 100%;
    margin-top: 25%;
  }
`;

export const Subtitle = styled.span`
  font-size: 1.125rem;
  font-weight: 300;
  color: #ffffff;
  opacity: 0.4;
  margin-top: 32px;

  @media (max-width: 1024px) {
    margin: 5% 15%;
    font-size: 2.5rem;
  }

  @media (max-width: 960px) {
    margin: 5% 15%;
    font-size: 1.3rem;
  }
`;

export const Paragraph = styled.p`
  font-size: 1.125rem;
  font-weight: 300;
  color: #ffffff;
  margin-top: 26px;

  @media (max-width: 1024px) {
    font-size: 2rem;
    margin: 5% 15%;
  }

  @media (max-width: 960px) {
    font-size: 1.2rem;
    margin: 5% 15%;
  }
`;

export const H3 = styled.h3`
  font-size: 2.125rem;
  font-weight: 300;
  color: #6c677a;
  margin: 26px 0 35px 0;

  @media (max-width: 1024px) {
    margin: 0 15% 5% 15%;
    font-size: 3rem;
  }

  @media (max-width: 960px) {
    margin: 5% 15% 10% 15%;
    font-size: 1.5rem;
  }
`;

export const ButtonContainer = styled.div`
  width: 408px;

  @media (max-width: 960px) {
    width: 85%;
    margin: 0 15%;
  }
`;
